import { screeningQuestionsSectionID } from '../../../components/Sections/ScreeningQuestions';
import type { BuyerBriefOverviewResponse, SeededSection, SectionsApiResponse } from '../types';
import { mapApiSectionToSeeded } from './mapApiSectionToSeeded';
import { mapMetadataQuestionToSeeded } from './mapMetadataQuestionToSeeded';

export const seedSectionsFromApi = (
    brief: BuyerBriefOverviewResponse,
    sectionApi: SectionsApiResponse
): SeededSection[] => {
    const generatedContent = brief.content?.generatedContent ?? [];

    const generatedSections = sectionApi.sections
        .filter((section) => section.id !== 'attachments' && section.id !== screeningQuestionsSectionID)
        .map((section) => mapApiSectionToSeeded({ section, brief, generatedContent }));

    const metadataSections = sectionApi.metadata_questions.map(mapMetadataQuestionToSeeded);

    return [...generatedSections, ...metadataSections];
};
